const CANCELLED_ROUTE_MESSAGES = ['Cancel rendering route', 'Route Cancelled'];

const CANCELLED_ROUTE_PREFIXES = ['Abort fetching component for route'];

/**
 * Next rejects the superseded render promise whenever a route transition is
 * replaced, and re-throws it on purpose, so it arrives as an unhandled error
 * even though the newer render took over and nothing failed.
 */
export function isIgnorableClientError(message: string): boolean {
  const trimmed = message.trim();
  if (!trimmed) return false;
  return (
    CANCELLED_ROUTE_MESSAGES.includes(trimmed) ||
    CANCELLED_ROUTE_PREFIXES.some((prefix) => trimmed.startsWith(prefix))
  );
}
